<span id="mitsScannerButtonWrapper" (click)="clickScannerButton()">
  <span class="mitsScannerButton disable-text-select" [ngClass]="{'fullSize': fullSize, 'fullHeight': fullHeight}"
    [ngStyle]="{'height': size + 'px', 'width': width? (width + 'px') : 'auto'}">
    <mits-icon name="scan"></mits-icon>
    <span *ngIf="text">{{ text }}</span>
  </span>
</span>